<!--Menu Bar-->
<div class="lock-to-top" style="background-color: #ffffff">
	<!--School Select-->
	<div class="selector-body">
		<div class="selector-item">
			<div>
				<label>School</label>
			</div>

			<div style="margin-left: 10px">
				<caass-schoolselector [ShowAll]="false" [Disabled]="loading || isProcessing" [TableTypeID]="4"> </caass-schoolselector>
			</div>
		</div>
	</div>

	<!--Buttons-->
	<div class="button-body flex">
		<button [disabled]="loading || isProcessing" class="btn btn-primary" style="margin-left: 0px" (click)="onRefresh()">Refresh</button>
	</div>
</div>

<!--Table-->
<div class="table-main-body">
	<p-table
		#mydt
		[value]="lstAllRecords"
		[loading]="loading"
		[paginator]="true"
		[(rows)]="pagerows"
		[(first)]="pagefirst"
		[showCurrentPageReport]="true"
		[resizableColumns]="false"
		sortMode="multiple"
		styleClass="p-datatable-striped"
		selectionMode="single"
		[(selection)]="SelectedPeriod"
		dataKey="PeriodID"
		(onFilter)="onHandleFilter($event)"
		(onSort)="onHandleSort($event)"
		(onRowSelect)="onRowSelect($event)"
		(onRowUnselect)="onRowUnselect($event)"
		currentPageReportTemplate="Showing {first} to {last} of {totalRecords} entries"
		[rowsPerPageOptions]="[5, 10, 25, 50]"
	>
		<!--Headers-->
		<ng-template pTemplate="header">
			<!--Filter or Select from Dropdown-->
			<tr>
				<!--INSERT CUSTOM FILTERS HERE-->

				<!--PeriodNo-->
				<th>
					<p-columnFilter type="text" field="PeriodNo" matchMode="contains" [showMenu]="true"></p-columnFilter>
				</th>

				<!--PeriodDesc-->
				<th>
					<p-columnFilter type="text" field="PeriodDesc" matchMode="contains" [showMenu]="true"></p-columnFilter>
				</th>

				<!--StartTime-->
				<th>
					<!-- <p-columnFilter type="text" field="StartTime" matchMode="contains" [showMenu]="true"></p-columnFilter> -->
				</th>

				<!--EndTime-->
				<th>
					<!-- <p-columnFilter type="text" field="EndTime" matchMode="contains" [showMenu]="true"></p-columnFilter> -->
				</th>

				<!--TardyTime-->
				<th>
					<!-- <p-columnFilter type="text" field="TardyTime" matchMode="contains" [showMenu]="true"></p-columnFilter> -->
				</th>
			</tr>

			<!--Column Names-->
			<tr style="height: 4rem">
				<!--INSERT CUSTOM COLUMNS HERE-->
				<th pSortableColumn="PeriodNo">Period Number<p-sortIcon field="PeriodNo"></p-sortIcon></th>
				<th pSortableColumn="PeriodDesc">Description<p-sortIcon field="PeriodDesc"></p-sortIcon></th>
				<th pSortableColumn="StartTime">Start Time<p-sortIcon field="StartTime"></p-sortIcon></th>
				<th pSortableColumn="EndTime">End Time<p-sortIcon field="EndTime"></p-sortIcon></th>
				<th pSortableColumn="TardyTime">Tardy Time<p-sortIcon field="TardyTime"></p-sortIcon></th>
			</tr>
		</ng-template>

		<!--Data-->
		<ng-template pTemplate="body" let-Period>
			<tr [pSelectableRow]="Period" (dblclick)="onRowDblClick(Period)">
				<td>{{ Period.PeriodNo }}</td>
				<td>
					<input type="text" class="form-control" [(ngModel)]="Period.PeriodDesc" />
				</td>

				<td>
					<p-calendar
						[timeOnly]="true"
						name="StartTime"
						(onSelect)="onChangeStartTime(Period)"
						(onBlur)="onChangeStartTime(Period)"
						[(ngModel)]="Period.StartTimeText"
						class="timer"
						hourFormat="12"
						appendTo="body"
					>
					</p-calendar>
				</td>

				<td>
					<p-calendar
						[timeOnly]="true"
						name="EndTime"
						(onSelect)="onChangeEndTime(Period)"
						(onBlur)="onChangeEndTime(Period)"
						[(ngModel)]="Period.EndTimeText"
						class="timer"
						hourFormat="12"
						appendTo="body"
					>
					</p-calendar>
				</td>

				<td>
					<p-calendar
						[timeOnly]="true"
						name="TardyTime"
						(onSelect)="onChangeTardyTime(Period)"
						(onBlur)="onChangeTardyTime(Period)"
						[(ngModel)]="Period.TardyTimeText"
						class="timer"
						hourFormat="12"
						appendTo="body"
					>
					</p-calendar>
				</td>

				<td>
					<button
						*ngIf="!Period.errorMessage && !Period.issaving"
						[disabled]="loading || isProcessing"
						class="btn btn-xs btn-primary"
						type="button"
						(click)="Save(Period)"
					>
						Save
					</button>
					<span *ngIf="Period.issaving" style="color: blue"> Please wait! Saving.. </span>
					<span *ngIf="Period.saved" style="color: green"> Record Saved! </span>
					<span *ngIf="Period.errorMessage" style="color: red"> {{ Period.errorMessage }}</span>
				</td>
			</tr>
		</ng-template>
	</p-table>
</div>

<!--Error Message-->
<div class="TopMargin">
	<div name="errorMessage" *ngIf="errorMessage" class="alert alert-danger">
		{{ errorMessage }}
	</div>
</div>
